import React, { useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { useBrandKitRepository } from '@bingads-webui-campaign-react/brandkit-data-service';
// TODO: MOVE THIS FILE TO BRANDKIT-DATA-SERVICE PACKAGE
export const withBrandKitService = (WrappedComponent) => {
  const Wrapper = (props) => {
    const dataService = useBrandKitRepository();
    const {
      getBrandKits,
      updateBrandKit,
      createBrandKits,
      brandkitResp,
      brandkitError,
      cache,
      brandkitLoading,
    } = dataService;
    const brandKitDataService = useMemo(() => ({
      getBrandKits,
      updateBrandKit,
      createBrandKits,
    }), [createBrandKits, getBrandKits, updateBrandKit]);
    const brandkitApiState = useMemo(() => ({
      brandkitResp,
      brandkitError,
      cache,
      brandkitLoading,
    }), [brandkitError, brandkitLoading, brandkitResp, cache]);
    return (
      <WrappedComponent
        {...props}
        brandKitDataService={brandKitDataService}
        brandkitApiState={brandkitApiState}
      />
    );
  };

  Wrapper.displayName = `withBrandKitService(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
};
